import slugify from 'slugify';
import { SUPPORTED_LANGUAGES } from '../../common/constants';
import leadingZero from './leadingZero';

export function buildSlugPathFromArticle(article) {
  return slugify(`${article.title || article.headline}-${article.legacyId}`, { lower: true, strict: true });
}

function buildArticlePathPrefix(date) {
  const articleDate = new Date(date.replace(' ', 'T'));
  const y = articleDate.getFullYear();
  const m = articleDate.getMonth() + 1; // getMonth returns 0-based value
  const d = articleDate.getDate();

  return `/newsroom/pressrelease/${y}/${leadingZero(m)}/${leadingZero(d)}/`;
}

export function buildSlugArticlePath(article) {
  const slug = buildSlugPathFromArticle(article);
  return `${buildArticlePathPrefix(article.date)}${slug}`;
}

export function buildIdArticlePath(article) {
  return `${buildArticlePathPrefix(article.date)}${article.legacyId}`;
}

/**
 * Formats a date string to a more readable format for our newsroom page
 * @param {string} dateStr - The date string to format
 * @param {string} lang - Language to format the date in
 * @returns {string} - The formatted date string.
 */
export function getNewsroomFormattedDate(dateStr, locale = SUPPORTED_LANGUAGES.ENGLISH) {
  const isoDate = `${dateStr.replace(' ', 'T')}`;

  return new Date(isoDate).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
